import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { WizDateUtils } from '@wizeoo/akm-core-lib';
import {
  WizDateField,
  WizIcon,
  WizNumericInput,
  WizPopUp,
  WizRoot,
  WizTextInput,
  WizValidationContainerDirective,
  WizValidationError,
  WizEventManager,
  WizTranslationManager,
  WizTimefield
} from '@wizeoo/akm-component-lib';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../../model/enums';
import { FIELD_KIND, FeiKeyDef, WidgetLine } from '@wizeoo/akm-compute-lib';
import { IWidget } from '../../../../../manager/widgets/i-widget';
import { Baseline, Measure } from '@wizeoo/akm-message-lib';
import { ThresholdField, ThresholdLine } from './pivot-cell-threshold-edit.pop';

@Component({
  selector: 'other-cell-editor',
  templateUrl: './other-cell.editor.html'
})
export class OtherCellEditor implements ICellEditorAngularComp, AfterViewInit, OnDestroy {

  /**
   * constructeur
   */
  constructor() { }


  /** Zone de validation des champs de saisie */
  @ViewChild('mainGP', { read: WizValidationContainerDirective, static: false })
  private mainGP: WizValidationContainerDirective;

  @ViewChild('ti', { read: WizTextInput }) public ti: WizTextInput;
  @ViewChild('ni', { read: WizNumericInput }) public ni: WizNumericInput;
  @ViewChild('da', { read: WizDateField }) public da: WizDateField;
  @ViewChild('tf', { read: WizTimefield }) public tf: WizTimefield;


  private params: any; // la conf issue du grid

  private currKey: string = null; // l'élément en saisie directe (valeur de clé)
  private doDelete: boolean = false; // on a appuyé sur suppr

  public isKey: boolean = false;
  public isNum: boolean = false;
  public isText: boolean = false;
  public isDate: boolean = false;
  public isTime: boolean = false;

  public textValue: string = null;
  public numValue: number = null;
  public dateValue: number = null;
  public timeValue: string = null;

  public forceCaps: string = ''; // forcer l'upperCase
  ngAfterViewInit() {
    // console.log('ngAfterViewInit', this.params);
    // focus on the input
    setTimeout(() => this.feed(), 0);
  }

  ngOnDestroy() {
    
  }

  private feed(): void {
    // console.log('feed', this.params.charPress, this.params.keyPress);
    if (this.params.charPress) {
      // injection directe d'une nouvelle valeur
      this.currKey = this.params.charPress;
    }
    if(this.params.keyPress === 46) {
      this.doDelete = true;
    }

    // console.log('editor feed', this.params.value); 
    if (this.isText) {
      if(this.doDelete) { // suppr
        this.textValue = null;
      }
      this.ti.wizValue = this.textValue;
      setTimeout(() => {
        this.ti.wizFocusInjector(this.currKey);
        // this.ti.wizFocus();
      }, 1);
    } else if (this.isNum) {  
      if(this.doDelete) { // suppr
        this.numValue = null;
      }
      this.ni.wizNumber = this.numValue; 
      this.ni.nbDecimal = 2;
      this.ni.allowNegative = true;
      setTimeout(() => {
        // this.ni.wizFocus();
        this.ni.wizFocusInjector(this.currKey);
      }, 1);
    } else if (this.isDate) {
      if(this.doDelete) { // suppr
        this.dateValue = null;
      }
      this.da.wizNumberValue = this.dateValue;
      setTimeout(() => {
        this.da.wizFocusInjector(this.currKey);
      }, 1);
    } else if (this.isTime) {
      if(this.doDelete) { // suppr
        this.timeValue = null;
      }
      this.tf.wizHourValue = this.timeValue;
      setTimeout(() => {
        this.tf.wizFocusInjector(this.currKey);
      }, 1);
    }
    // this._clipboardService.copy(this.params.value); // copie vers clipboard
  }

  agInit(params: any): void {
    this.params = params;

    let tsf: ThresholdField = this.params?.colDef.tsf;
    let tl: ThresholdLine = this.params?.data;

    if (tsf) {
        switch (tsf.kind) {
          case FIELD_KIND.INT:
          case FIELD_KIND.NUMBER:
          // case FIELD_KIND.BOOLEAN:
            this.isNum = true;
            this.numValue = Number(this.params.value);
            break;
          case FIELD_KIND.DATE:
            this.isDate = true;
            this.dateValue = Number(this.params.value); // la saisie sera injectée sur afterInit pour la prise de focus
            break;
          case FIELD_KIND.TIME:
            this.isTime = true;
            this.timeValue =this.params.value;
            break;         
          case FIELD_KIND.STRING:
          case FIELD_KIND.COMMENT:
            this.isText = true;
            this.textValue = this.params.value;
            break;
        }
    } else {
      // pas de dataKind, on prend texte
      this.isText = true;
      this.textValue = this.params.value;
    }
  }


  /* Component Editor Lifecycle methods */
  // the final value to send to the grid, on completion of editing
  getValue() {

    // console.log('editor getValue', this.params.value); 
    // TODO TODO sync dateField sur saisie + TAB
    let result: string = '';
    if(this.isDate) {
      this.da.prepareForCheck(); // on force le refresh de la date
    }
    if(this.isTime) {
      this.tf.prepareForCheck(); // on force le refresh de l'heure
    }
   
    const errors = this.mainGP.check(true, true);
    if (errors && errors.length > 0) {
      errors.forEach((wve: WizValidationError) => {
        let mess: string = WizTranslationManager.getInstance().translateKey(wve.wizError, wve.wizErrorParams);
        WizPopUp.toast(mess, WizIcon.TOAST_ERROR).show();
      });
      return this.params.value; // pas de changement
    }

    // console.log('err', errors);
    if (this.isText) {
      // une mesure de type texte
      result = this.ti.wizValue;
    } else if (this.isNum) {
      // une mesure numérique
      if (this.ni.wizValue !== null) {
        result = this.ni.wizNumber.toString();
      }
    } else if (this.isDate) {
      // une mesure de type date
      this.da.prepareForCheck(); // on force le refresh de la date
      // console.log('datecheck', this.da.wizDateValue);
      result = this.da.wizDateValue ? WizDateUtils.dateToString(this.da.wizDateValue) : null;
    } else if (this.isTime) {
      // une mesure de type heure
      this.tf.prepareForCheck(); // on force le refresh de la date
      // console.log('datecheck', this.da.wizDateValue);
      result = this.tf.wizHourValue ? this.tf.wizHourValue : null;
    }
    
    return result;
  }

  // Gets called once before editing starts, to give editor a chance to
  // cancel the editing before it even starts.
  isCancelBeforeStart() {
    // console.log('isCancelBeforeStart', this.params);

    if (this.params.colDef?.fkd?.datakind === FIELD_KIND.BOOLEAN || 
      this.params.colDef?.fkd?.datakind === FIELD_KIND.BINARY ||
      this.params.colDef?.fkd?.datakind === FIELD_KIND.FILTER ||
      this.params.colDef?.fkd?.datakind === FIELD_KIND.CROSS_FILTER ||
      this.params.colDef?.fkd?.datakind === FIELD_KIND.WORKFLOW ||
      this.params.colDef?.fkd?.datakind === FIELD_KIND.LIST) { // pas de 2xclic sur le checkbox
      // console.log('no cbx on pivotcelleditor', this.params);
      return true;
    }

    return false;
  }

  // Gets called once when editing is finished (eg if Enter is pressed).
  // If you return true, then the result of the edit will be ignored.
  isCancelAfterEnd() {
    // our editor will reject any value greater than 1000
    // console.log('cancel sur modif datacommit', this.imDead);
    return false; // this.value > 1000;
  }

  // rafraichissement de la donnée de l'éditor à partir du pivot
  public refresh(e:AlkEvent) {
    // console.log('pce refresh', e);
    const value = this.params.colDef.valueGetter(this.params);
    this.textValue = value;

    let tsf: ThresholdField = this.params?.colDef.tsf;
    let tl: ThresholdLine = this.params?.data;

    if (tsf) {
        switch (tsf.kind) {
        case FIELD_KIND.INT:
        case FIELD_KIND.NUMBER:
        case FIELD_KIND.BOOLEAN:
          this.numValue = Number(value);
          break;
        case FIELD_KIND.DATE:
          this.dateValue = Number(value); 
          break;
        case FIELD_KIND.TIME:
          this.timeValue = value; 
          break;
      }
    }  

    this.feed();  
  } 
}
